export default "__VITE_ASSET__CLFkexTc__"